import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER, NOT_AVAILABLE, warningTypeColorMap } from 'core/constants';
import { TextLine, WarningCell } from 'core/elements';
import { WarningType } from 'core/enums';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { QuotePartHelper } from 'quotes/helpers';

interface IProps extends ICellRendererParams {
  isAlternateVersionEnabled: boolean;
}

export const CorporateLocationCell = ({
  value: corporateLocation,
  node,
  isAlternateVersionEnabled,
}: IProps) => {
  const isGroupedByColumn = QuotePartColId.SHIPPING_LOCATION === node?.rowGroupColumn?.getColId();

  if (!corporateLocation?.id && node?.group && !isGroupedByColumn) {
    return '';
  }

  const showWarning = !QuotePartHelper.isShippingLocationValid({
    corporateLocation,
    alternateVersionEnabled: isAlternateVersionEnabled ? 1 : 0,
  });

  const vendorId = isAlternateVersionEnabled
    ? corporateLocation?.externalLocationId
    : corporateLocation?.vendorIdentifier;

  const content = !corporateLocation?.id ? (
    DEFAULT_PLACEHOLDER
  ) : (
    <Stack>
      <TextLine
        color={showWarning ? warningTypeColorMap[WarningType.ERROR] : null}
        text={corporateLocation.addressName || NOT_AVAILABLE}
      />
      <TextLine text={vendorId} isSubText />
    </Stack>
  );

  return (
    <WarningCell
      content={content}
      showWarning={showWarning}
      type={WarningType.ERROR}
      sx={{ justifyContent: 'flex-start', alignItems: 'center' }}
    />
  );
};
